<template>
    <div class="relative inline-block text-[#272828]">
      <span class=" text-[36px]">
        <slot>标题</slot>
      </span>
      <img :src="$getImageSrc('index-title-bg.png')" class="absolute w-[315px] h-[15px] max-w-none -bottom-[20px]">
    </div>
</template>

<script>
export default{
    name:'Title',
}
</script>

<style lang="scss" scoped>
    
</style>